var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "TeamSelected_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB1FD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#148CFC",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 110 16A8 8 0 018 0zm.007 8.28c-1.562 0-2.828 1.252-2.828 2.797 0 .171.015.339.045.503.715.519 1.698.84 2.783.84s2.068-.321 2.782-.841c.03-.163.046-.33.046-.502 0-1.545-1.266-2.797-2.828-2.797zm2.821-.56c-.465 0-.897.14-1.257.378a3.352 3.352 0 011.83 2.979l-.003-.116c.753-.257 1.353-.78 1.65-1.436a2.257 2.257 0 00-2.22-1.805zm-5.656 0c-1.1 0-2.016.776-2.22 1.805.299.66.904 1.185 1.663 1.439A3.354 3.354 0 016.435 8.1a2.27 2.27 0 00-1.263-.38zm2.835-3.356c-.937 0-1.697.751-1.697 1.678 0 .927.76 1.678 1.697 1.678s1.696-.751 1.696-1.678c0-.927-.76-1.678-1.696-1.678zm2.821.56c-.278 0-.534.099-.73.265a2.21 2.21 0 010 1.707c.196.165.452.265.73.265.625 0 1.131-.501 1.131-1.119s-.506-1.119-1.13-1.119zm-5.656 0c-.625 0-1.131.5-1.131 1.118 0 .618.506 1.119 1.131 1.119.283 0 .542-.103.74-.274a2.21 2.21 0 010-1.691 1.134 1.134 0 00-.74-.273z",
    fill: "url(#TeamSelected_svg__[object_Object]a)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamSelected);
export default ForwardRef;